export interface QuestInterface {
  id: bigint
  name: string
  description: string
}

export class QuestDTO implements QuestInterface {
  id = 0n
  name = ''
  description = ''
}

export default class Quest extends QuestDTO {
  constructor(DTO: QuestDTO) {
    super()
    Object.assign(this, DTO)
  }
}
